import React from 'react';
import Select from 'react-select';
import {Field, Fields, reduxForm, actionTypes} from 'redux-form';
import ShowContactPerson from "../contact-person/ShowContactPerson";
import MultiSelect from './MultiSelect';
import LimitedMultiSelect from './LimitedMultiSelect';
import PublishAt from './PublishAt';
import VideoUploadRedux from '../VideoUploadRedux';
import FileUpload from '../files/FileUpload';
import ValidatedInputField from '../common/form/ValidatedInputField';
import {validate} from './validate.js';
import SubmitButton from "../common/SubmitButton";
import ResetButton from "../common/ResetButton";
import {FormattedMessage, injectIntl} from 'react-intl';
import {messages} from '../common/Translations';
import PrivateAPIResource from "../../services/PrivateAPIResource";
import DropDownOptions from '../helpers/DropDownOptions';
import ReactSelect from '../common/ReactSelect';
import RteEditor from "../common/form/RteEditor";
import afterSubmitFail from '../common/form/focusAfterSubmitFail';

class ArticleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {showOldCategories: true};
    }

    showArticlePreviewModal() {
        Object.keys(this.props.initialValues).forEach((fieldName) => this.props.touch(fieldName));
        this.props.showArticlePreviewModal();
    }

    deleteOldCategories() {
        let id = this.props.initialValues.id;
        PrivateAPIResource.remove(`articles/${id}`, 'old-categories').then(response => this.setState({showOldCategories: false}));
    }

    renderOldCategories() {
        let oldCategories = this.props.initialValues.oldCategories || [];
        if (oldCategories.length > 0 && this.state.showOldCategories) {
            return (
                <div className="form-group row">
                    <label className="col-2 col-form-label">
                        <b> {this.props.intl.formatMessage(messages.oldCategoriesLabel)}</b>
                    </label>
                    <div className="col-7">
                        <Select
                            disabled={true}
                            multi
                            options={oldCategories}
                            simpleValue
                            value={oldCategories.map(c => c.value)}
                        />
                    </div>
                    <div className="col-3">
                        <button
                            className="btn btn-outline-danger waves-effect waves-light pull-right"
                            onClick={this.deleteOldCategories.bind(this)}
                            type='button'>
                            {this.props.intl.formatMessage(messages.deleteOldCategoriesButton)}
                        </button>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        const {handleSubmit, contactPersons, handleModalClick, handleReset,
            templates, categories, isUpdate, isAdmin, isLoggedInAs, sentOutAt} = this.props;

        let imageSizeLimit = (MAX_IMAGE_SIZE > 1) ? MAX_IMAGE_SIZE - 1 : 1;
        let fileSizeLimit = (MAX_FILE_SIZE > 1) ? MAX_FILE_SIZE - 1 : 1;

        return (
            <form onSubmit={handleSubmit} noValidate={true}>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b> {this.props.intl.formatMessage(messages.contactPerson)}</b>
                    </label>
                    <div className="col-sm-10">
                        <Field
                            type="select"
                            name="contactPersonId"
                            component={ReactSelect}
                            options={DropDownOptions.getOptions(contactPersons, 'id', 'name')}
                            placeholder={this.props.intl.formatMessage(messages.contactPersonSelect)}
                        />
                        <Field
                            type="button"
                            name="showModal"
                            onChage={handleModalClick}
                            component={ShowContactPerson}
                            props={{handleModalClick: handleModalClick}}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{this.props.intl.formatMessage(messages.comments)}</b>
                    </label>
                    <div className="col-sm-10">
                        <label className="custom-control custom-checkbox">
                            <Field
                                type="checkbox"
                                name="isCommentsAllowed"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                            <span className="custom-control-description">
                                {this.props.intl.formatMessage(messages.commentsDescription)}
                            </span>
                        </label>
                    </div>
                </div>
                <Field
                    type="datePicker"
                    name='publishAt'
                    component={PublishAt}
                />
                { sentOutAt &&
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>Udsendt i nyhedsbrev</b>
                    </label>
                    <div className="col-sm-10">
                        <label className="col-form-label">{sentOutAt}</label>
                    </div>
                </div>
                }
                <div data-cy-article-category className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{this.props.intl.formatMessage(messages.categories)}</b>
                    </label>
                    <div className="col-sm-10">
                        <Field
                            type="select"
                            name="categoryIds"
                            component={LimitedMultiSelect}
                            options={categories}
                            labelName={this.props.intl.formatMessage(messages.categories)}
                            placeholer={this.props.intl.formatMessage(messages.categoriesSelect)}
                        />
                    </div>
                </div>
                {this.renderOldCategories()}
                <hr/>
                <Field
                    type="text"
                    name="heading"
                    component={ValidatedInputField}
                    placeholder={this.props.intl.formatMessage(messages.headingPlaceholder)}
                    className="form-control"
                    label={this.props.intl.formatMessage(messages.heading)}
                />
                <Field
                    type="text"
                    name="resume"
                    component={ValidatedInputField}
                    placeholder={this.props.intl.formatMessage(messages.resumePlaceholder)}
                    className="form-control"
                    label={this.props.intl.formatMessage(messages.resume)}
                />
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{this.props.intl.formatMessage(messages.images) + this.props.intl.formatMessage(messages.optional)}</b>
                        <small className="form-text text-muted">
                            {`${this.props.intl.formatMessage(messages.filesMaxSize)} ${imageSizeLimit} MB.`}
                        </small>
                    </label>
                    <div className="col-sm-10">
                        <Fields
                            type="file"
                            names={[
                                'images',
                                'defaultImages',
                                'defaultImageIds',
                            ]}
                            component={FileUpload}
                            props={{
                                postUrl: 'api/privateV1/articles/validate-images',
                                type: 'image'
                            }}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>
                            {this.props.intl.formatMessage(messages.catalogs) +
                            this.props.intl.formatMessage(messages.optional)}
                        </b>
                        <small className="form-text text-muted">
                            {`${this.props.intl.formatMessage(messages.filesMaxSize)} ${fileSizeLimit} MB.`}
                        </small>
                    </label>
                    <div className="col-sm-10">
                        <Fields
                            type="file"
                            names={[
                                'files',
                                'defaultFiles',
                                'defaultFileIds',
                            ]}
                            component={FileUpload}
                            props={{
                                postUrl: 'api/privateV1/articles/validate-files',
                                type: 'file'
                            }}
                        />
                    </div>
                </div>
                <div data-cy-article-description>
                    <Field
                        type="text"
                        name="description"
                        component={RteEditor}
                        placeholder={this.props.intl.formatMessage(messages.descriptionPlaceholder)}
                        className="form-control"
                        editorName={'articleDescription'}
                        label={this.props.intl.formatMessage(messages.description)}
                    />
                </div>
                <Fields
                    type="text"
                    names={[
                        'youtubeId',
                        'vimeoId',
                        'vimeoName',
                        'vimeoDescription',
                    ]}
                    component={VideoUploadRedux}
                />
                { isLoggedInAs && <hr/>}
                { isLoggedInAs &&
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>Forfattet af FBG</b><small className="form-text text-muted">(Medtag i nyhedsbrev)</small>
                    </label>
                    <div className="col-sm-10">
                        <label className="custom-control custom-checkbox">
                            <Field
                                type="checkbox"
                                name="authoredByFBG"
                                component="input"
                                className="custom-control-input"
                            />
                            <span className="custom-control-indicator"> </span>
                            <span className="custom-control-description"></span>
                        </label>
                    </div>
                </div>
                }
                <hr/>
                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={isUpdate}/>
                            <ResetButton onClick={handleReset}/>
                            <button
                                data-cy-article-preview
                                type="button"
                                className="btn btn-secondary waves-effect waves-light ml-3"
                                onClick={this.showArticlePreviewModal.bind(this)}
                            >
                                {this.props.intl.formatMessage(messages.browse)}
                            </button>
                        </div>
                    </div>
                </div>

            </form>
        );
    }
}

ArticleForm = reduxForm({
    form: 'article',
    validate,
    onSubmitFail: afterSubmitFail
})(ArticleForm);

export default injectIntl(ArticleForm);


// WEBPACK FOOTER //
// ./web/src/components/articles/ArticleForm.jsx